import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PopupReducerState {
  isOpen: boolean;
  componentName?: string;
  componentProps?: Record<string, unknown>;
}

export const initialState: PopupReducerState = {
  isOpen: false,
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    openPopup(state) {
      state.isOpen = true;
    },

    closePopup(state) {
      state.isOpen = false;
    },

    setPopupProps(
      state,
      action: PayloadAction<{
        componentName: string;
        componentProps: Record<string, unknown>;
      }>
    ) {
      const {
        payload: { componentProps, componentName },
      } = action;
      state.componentName = componentName;
      state.componentProps = componentProps;
    },

    updatePopupProps(state, action: PayloadAction<Record<string, unknown>>) {
      const { payload: componentProps } = action;
      state.componentProps = { ...state.componentProps, ...componentProps };
    },

    resetPopup(state) {
      state.isOpen = false;
      state.componentName = undefined;
      state.componentProps = {};
    },
  },
});

export const {
  closePopup,
  openPopup,
  resetPopup,
  setPopupProps,
  updatePopupProps,
} = popupSlice.actions;
